import Client from './Clients/ScrapingToolsClient'
import RepoUtils from './RepoUtils'

const resource = '/catalog/job/'
const viewResource = '/catalog/job_view/'
const idNameResource = '/catalog/job_id_name_table/'

export default {
    get(){
        return Client.get(viewResource);
    },
    get(id){
        return Client.get(viewResource+'?id='+id);
    },
    post(payload){
        return Client.post(viewResource,payload);
    },
    put(payload){
        return Client.put(viewResource,payload);
    },
    delete(id){
        return Client.delete(resource+id+'/');
    },
    idNameTable(pageNumber,filters){
        filters.page=pageNumber;
        return Client.get(RepoUtils.parseResourceWithQueryParams(idNameResource,filters));
    }
}